import { fetchVendorStatus } from '@/queries/adminVendors/adminVendorsQueries'

export default defineNuxtRouteMiddleware(async () => {
  const user = useSupabaseUser().value
  if (!user)
    return navigateTo('/')

  try {
    const { isVendor } = await fetchVendorStatus()
    if (!isVendor)
      return await navigateTo('/')
  }
  catch {
    return navigateTo('/')
  }
})
